import classes from "./EarTrainerSetup.module.css";
import EarTrainerChartSelect from "./EarTrainerChartSelect";
import EarTrainerRootSelect from "./EarTrainerRootSelect";
import EarTrainerShowNotesSelect from "./EarTrainerShowNotesSelect";
import EarTrainerQuestionTypeSelect from "./EarTrainerQuestionTypeSelect";
import EarTrainerShapeChangeSelect from "./EarTrainerShapeChangeSelect";
import EarTrainerStartTrainingSelect from "./EarTrainerStartTrainingSelect";
import EarTrainerIgnoreOctavesSelect from "./EarTrainerIgnoreOctavesSelect";
import EarTrainerRootOctaveSelect from "./EarTrainerRootOctaveSelect";
import EarTrainerAudioStatus from "./EarTrainerAudioStatus";

const EarTrainerSetup = ({ charts, selectedIndex, trainingUnavailable, audio, onStart, onRetry, onResume, starting }) => {
  return (
    <table className={classes.tableLayout} data-tour-target="ear-options">
      <tbody>
        <EarTrainerChartSelect charts={charts} selectedIndex={selectedIndex} />
        <EarTrainerRootSelect />
        <EarTrainerRootOctaveSelect />
        <EarTrainerShowNotesSelect />
        <EarTrainerQuestionTypeSelect />
        <EarTrainerIgnoreOctavesSelect />
        <EarTrainerShapeChangeSelect />
        <EarTrainerAudioStatus audio={audio} onRetry={onRetry} onResume={onResume} />
        <EarTrainerStartTrainingSelect trainingUnavailable={trainingUnavailable || audio.status !== "ready" || starting}
          onStart={onStart} />
      </tbody>
    </table>
  );
};

export default EarTrainerSetup;
